/* refactored - ali */
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import "./Portal.css";

export const PortalCard = ({ portal, project, clone, goToPortal, isMobile }) => {

    const cloneButton = useRef(null);

    const { t } = useTranslation([
        "portal/common",
    ], {
        useSuspense: false
    })

    function handleClone(e) {
        e.preventDefault();
        clone(portal);
    }

    function handleCardClick(e) {
        if (cloneButton && cloneButton.current && cloneButton.current.contains(e.target)) {
            handleClone();
        } else {
            goToPortal(portal);
        }
    }

    // Get portal icon color - default to blue if none specified
    const getIconColor = () => {
        if (portal.IconColor) return portal.IconColor;
        // Default colors based on portal name for variety
        const colors = ['#1976d2', '#dc2626', '#059669', '#7c3aed', '#ea580c'];
        const index = portal.portalName.charCodeAt(0) % colors.length;
        return colors[index];
    };

    // Get portal icon - default to user icon if none specified
    const getPortalIcon = () => {
        if (portal.Icon) return portal.Icon;
        // Default icons based on portal name
        if (portal.portalName.toLowerCase().includes('admin')) return 'fas fa-user-shield';
        if (portal.portalName.toLowerCase().includes('teacher')) return 'fas fa-chalkboard-teacher';
        return 'fas fa-user';
    };

    return (
        <div className="cursor-pointer" onClick={handleCardClick}>
            <div className="portal-card">
                <div className="p-4 position-relative">
                    {/* Mobile indicator for mobile portals */}
                    {isMobile && (
                        <div className="portal-mobile-indicator">
                            <i className="fas fa-mobile-alt"></i>
                        </div>
                    )}
                    
                    {/* Portal Icon */}
                    <div className="mb-3">
                        <div 
                            className="portal-icon-circle"
                            style={{ backgroundColor: getIconColor() }}
                        >
                            <i className={getPortalIcon()}></i>
                        </div>
                    </div>

                    {/* Portal Title */}
                    <div className="mb-3">
                        <h6 className="portal-title mb-0">
                            {portal.portalName}
                        </h6>
                    </div>

                    {/* Portal Description */}
                    {portal.portalDescription && (
                        <div className="mb-3">
                            <p className="portal-description mb-0">
                                {portal.portalDescription}
                            </p>
                        </div>
                    )}

                    {/* Update Information */}
                    <div className="portal-update-info">
                        <div className="portal-update-label">
                            {t("portal_card.updated_on")}
                        </div>
                        <div className="portal-update-date">
                            {new Date(portal.updatedDate).toLocaleString()}
                        </div>
                    </div>

                    {/* Clone Button (if developer mode) */}
                    {project.developerMode && (
                        <div className="mt-3">
                            <button
                                className="btn btn-outline-secondary btn-sm portal-clone-button"
                                onClick={handleClone}
                                title="Clone Portal"
                                ref={cloneButton}
                            >
                                <i className="fas fa-clone me-1"></i>
                                {t("portal_card.buttons.clone_portal_button_label")}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
